/**
 * Iter 45r — Quick Session choice modal.
 *
 * After the user clicks the "Quick Session" quick-action, they pick:
 *   - Start Live Data    → existing /session?quick=true flow
 *   - Document Session   → opens DocumentQuickSessionDialog
 *
 * Pure routing surface — no data fetched, no state owned.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Lightning, Notepad } from "@phosphor-icons/react";

export default function QuickSessionChoiceDialog({ open, onOpenChange, onStartLive, onDocument }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-md bg-[#FBFAF6]"
        data-testid="quick-session-choice-dialog"
      >
        <DialogHeader>
          <DialogTitle className="text-[#1F2937] heading-font">
            How would you like to document this session?
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-2 py-2">
          <button
            type="button"
            data-testid="quick-choice-live-data"
            onClick={() => {
              onOpenChange(false);
              onStartLive();
            }}
            className="w-full text-left p-4 rounded-xl border border-[#E5E3DB] bg-white hover:border-[#1E3F33]/40 hover:shadow-sm transition flex items-start gap-3"
          >
            <div className="w-9 h-9 rounded-lg bg-[#E8F0EB] flex items-center justify-center shrink-0">
              <Lightning size={18} weight="duotone" className="text-[#1E3F33]" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[#1F2937] heading-font">Start Live Data</p>
              <p className="text-xs text-[#6B7280] mt-0.5">
                Use this when you want to collect data during the session.
              </p>
            </div>
          </button>

          <button
            type="button"
            data-testid="quick-choice-document"
            onClick={() => {
              onOpenChange(false);
              onDocument();
            }}
            className="w-full text-left p-4 rounded-xl border border-[#E5E3DB] bg-white hover:border-[#9C6B2E]/40 hover:shadow-sm transition flex items-start gap-3"
          >
            <div className="w-9 h-9 rounded-lg bg-[#FDF8F3] flex items-center justify-center shrink-0">
              <Notepad size={18} weight="duotone" className="text-[#9C6B2E]" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[#1F2937] heading-font">Document Session</p>
              <p className="text-xs text-[#6B7280] mt-0.5">
                Use this when you want to log service, notes, goals addressed, and optional progress data without live data collection.
              </p>
            </div>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
